import { inject, Injectable } from '@angular/core';
import { ToastsService } from '@catch/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, tap } from 'rxjs/operators';
import { UserAdapter } from '../../adapters/user.adapter';
import {
  loadTFAMethods,
  loadTFAMethodsFailure,
  loadTFAMethodsSuccess,
} from './tfa-methods.actions';

@Injectable()
export class TfaMethodEffects {
  private readonly actions$ = inject(Actions);
  private readonly userAdapter = inject(UserAdapter);
  private readonly toastsService = inject(ToastsService);

  loadTfaMethods$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadTFAMethods),
      exhaustMap(() =>
        this.userAdapter.getAuthenticationMethods().pipe(
          map((tfaMethods) => loadTFAMethodsSuccess({ tfaMethods })),
          catchError((error) => {
            return of(loadTFAMethodsFailure({ error }));
          })
        )
      )
    )
  );

  loadTfaMethodsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadTFAMethodsFailure),
        tap(() => {
          // Todo: Add proper error handling. Maybe with a toasty?
        })
      ),
    { dispatch: false }
  );
}
